import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { API_GET_MAIN_LAUNDRY } from "api/main-laundry-management";
import { Skeleton } from "antd";

const ViewLaundry = () => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  // const data = location.state && location.state.data;

  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  let { id } = useParams();

  const fetchData = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_MAIN_LAUNDRY(id);
      console.log("provider", newData);
      setData(newData?.laundry);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }
  useEffect(() => {
    fetchData();
  }, [id]);
  return (
    <>
      {/* <div className="mt-10 flex items-center justify-center">
          <Skeleton active style={{ width: "80%" }} />
        </div> */}

      <div className="flex gap-8">
        <div style={styles.container} className="min-h-[37rem]">
          <table style={styles.table}>
            <tbody>
              <div
                className="flex cursor-pointer items-center gap-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <MdOutlineArrowBack
                  className="cursor-pointer"
                  style={{ fontSize: "17px" }}
                />
                <p>Back</p>
              </div>
              <p className="mb-4 text-center text-[20px] font-semibold">
                View Main Laundry
              </p>
              <hr className="mb-4" />
              {/* Store Owner Information */}
              <div className="mb-3 flex justify-around">
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {t("Laundry Name")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {data?.laundry_name}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {t("Phone No")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {data?.phone_no}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {t("Password")}
                  </td>
                  <td className="flex w-[12rem] justify-between pl-4 text-[14px] font-semibold">
                    <p title={data?.unhashed_password}>
                      {showPassword
                        ? truncateText(data?.unhashed_password, 15)
                        : truncateText("*".repeat(data?.unhashed_password.length), 15)}
                    </p>{" "}
                    <button
                      type="button"
                      onClick={() => setShowPassword((prevState) => !prevState)}
                      // className="absolute bottom-[-20px] right-4 top-3"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                    </button>
                  </td>
                </tr>
              </div>

              <div className="mb-3 flex justify-around">
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {t("Email")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {data?.email}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {t("Description")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {data?.description}
                  </td>
                </tr>
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px]"
                    style={styles.label}
                  >
                    {t("Location")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] font-semibold">
                    {data?.location?.address}
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
// style={{ background: "#e5e2e2" }}

const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewLaundry;
